import moment from 'moment';
import 'moment/locale/es';
//moment.locale('es')

export const dateToMomentFormat = (date, format = "YYYY-MM-DD", locale = "en") => {
  const convertTime = moment(date).locale(locale).format(format);
  return convertTime;
};